import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const MySpaceTitle = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  background-color: ${({ theme }) => theme.neutral.gray[200]};
  padding: 0.5em;
  margin-left: -2em;
  margin-bottom: 0.5em;
  font-size: 13px;
`;

export const MySpaceDescription = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0em 0.5em 0.7em 0.5em;
  margin-left: -2em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[900]};
  margin-bottom: 0.5em;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
`;

export const DateDescription = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0 0.5em;
  margin-bottom: 0.5em;
  margin-left: -2em;
  font-size: 13px;
`;

export const ContentDescriptLang = styled.span`
  display: flex;
  align-items: center;
`;

export const ContentTooltip = styled.div`
  padding: 0.5em;
  span {
    font-size: 11px;
    color: #181818;
  }
`;

export const useStyles = makeStyles(() => ({
  containerSpace: {
    flexDirection: "row !important",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  imgOtherEvent: {
    width: "100%",
    height: "130px",
    borderRadius: "3px",
  },
  cardRightContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}));
